import React from 'react';

const Instructions = () => {
    return (
        <div id="instructions">
            Click each president sequentially (without clicking any twice) to win the game!
        </div>
    );
};

export default Instructions;
